// extracted by mini-css-extract-plugin
export var card = "style-module--card--3aee8";
export var content = "style-module--content--ebe10";
export var description = "style-module--description--44ae0";
export var head = "style-module--head--3e14c";
export var image = "style-module--image--2df28";
export var more = "style-module--more--cc9ef";
export var writer = "style-module--writer--3f0dd";